/** @file readPngSize: the width and height a PNG declares in its IHDR, without inflating it. */
import { readChunks } from '@zilo/pose3d-image-io/png/readChunks';
import { readHeader } from '@zilo/pose3d-image-io/png/readHeader';

/** `[width, height]` of a PNG; throws image-io's PNG errors (bad signature, no IHDR first, bad header). */
export function readPngSize(png: Uint8Array): [number, number] {
  const first = readChunks(png)[0];
  if (first?.type !== 'IHDR') throw new Error('not a PNG: the first chunk is not IHDR');
  const header = readHeader(first.data);
  return [header.width, header.height];
}
